import controller from './contact.controller';

const template = require('./contact.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
